import React from 'react'
import styled from 'styled-components'

type TWrapper = {
  inline?: boolean
}
const Wrapper = styled.div<TWrapper>`
  display: flex;
  flex-direction: ${({ inline }) => (inline ? 'row' : 'column')};
`
Wrapper.displayName = 'RadioGroupWrapper'

export type TRadioGroup = {
  inline?: boolean
  children?: React.ReactNode
}
const RadioGroup = (props: TRadioGroup): React.ReactElement => {
  const { children, inline = false } = props

  // TODO: provide context for childrens tab/arrow navigation
  return (
    <Wrapper className={inline ? 'm-n1' : ''} inline={inline}>
      {React.Children.map(
        children,
        (child, index) =>
          child && (
            <div className={inline ? 'm-1' : ''} key={index}>
              {child}
            </div>
          ),
      )}
    </Wrapper>
  )
}

export default RadioGroup
